export function canStackZekrBody(): boolean {
	return window.innerWidth >= 481;
}
